import moment from "moment";

class registrations {
  constructor(
    conceptId,
    csCostId,
    empId,
    entProcId,
    entry,
    originEntry,
    liqTotal,
    movimId,
    nameConcept,
    nameCsCost,
    observations,
    exitProcId,
    exit,
    originExit,
    entModif,
    salModif,
    pendNoved
  ) {
    this.conceptId = conceptId;
    this.csCostId = csCostId;
    this.empId = empId;
    this.entProcId = entProcId;
    this.pendingNovelty = pendNoved;

    /* ===================== ENTRADA ===================== */

    this.entryWithModif = entModif
      ? "* " +
        moment.utc(originEntry).format("DD-MM-YYYY") +
        " " +
        moment(originEntry).parseZone().format("HH:mm")
      : moment.utc(originEntry).format("DD-MM-YYYY") +
        " " +
        moment(originEntry).parseZone().format("HH:mm");

    this.entry =
      moment.utc(originEntry).format("DD-MM-YYYY") +
      " " +
      moment(originEntry).parseZone().format("HH:mm");

    this.originEntry = originEntry;

    /* ===================== SALIDA ===================== */

    // Fuente real de salida
    const exitSource = originExit ?? exit ?? null;

    let exitMoment = exitSource ? moment(exitSource) : null;

    // Si es liquidación total, restar un día
    if (exitMoment && liqTotal) {
      exitMoment = exitMoment.subtract(1, "day");
    }

    const formattedExit = exitMoment
      ? moment.utc(exitMoment).format("DD-MM-YYYY") +
        " " +
        exitMoment.parseZone().format("HH:mm")
      : "";

    this.exit = formattedExit;

    this.exitWithModif =
      formattedExit && salModif ? "* " + formattedExit : formattedExit;

    this.originExit = originExit;
    this.exitProcId = exitProcId;

    /* ===================== OTROS ===================== */

    this.liqTotal = liqTotal;
    this.movimId = movimId;
    this.nameConcept = nameConcept;
    this.nameCsCost = nameCsCost;
    this.observations = observations;

    this.id = empId.toString() + entry;
    this.entModif = entModif;
    this.salModif = salModif;

    if (entry === exit) {
      this.entryWithModif = "";
    }
  }

  static fromJson({
    ConceptoId,
    CsCostoId,
    EmpId,
    EntProcId,
    Entrada,
    EntradaOriginal,
    LicTot,
    MovimId,
    NomConcepto,
    NomCsCosto,
    Observaciones,
    SalProcId,
    Salida,
    SalidaOriginal,
    EntModif,
    SalModif,
    PendNoved,
  }) {
    return new registrations(
      ConceptoId,
      CsCostoId,
      EmpId,
      EntProcId,
      Entrada,
      EntradaOriginal,
      LicTot,
      MovimId,
      NomConcepto,
      NomCsCosto,
      Observaciones,
      SalProcId,
      Salida,
      SalidaOriginal,
      EntModif,
      SalModif,
      PendNoved
    );
  }
}

export default registrations;
